
$( document ).ready(function() {
  Modal = function(){
      if(Modal.modals === undefined) Modal.modals = [];
      Modal.modals.push(this);
      // defaultní parametry
      this.params = {
          'type': 'window', // menu
          'overlay': 'none',
          'effect': 'none',
          'modalClass': '',
          'menuAlign': 'center'
      };


      this.render = function() {
          this.modalElement = $('<div/>', {
                class: 'modal'
          }).appendTo('body').html(this.content);
          if(this.params.overlay!='none'){
              this.overlayElement = $('<div/>', {
                    class: this.params.overlay
              }).appendTo('body');
          }


      };


      this.timer = 0;
      this.root;
      this.open = function(time,speed)
      {
          if(this.root !== undefined) {
              $(this.root).addClass('active');
          }
          this.recalculatePosition();
          $(this.modalElement).slideDown(speed);
          $(this.overlayElement).slideDown(speed);
          if(this.timer) {
              clearTimeout(this.timer);
              this.timer = 0;
          }
          if(time !== undefined) this.timer = setTimeout(function(_this)
          {
              _this.close();
          }.bind(null, this), time);
      };

      this.close = function()
      {
          if(this.root !== undefined) $(this.root).removeClass('active');
          $(this.modalElement).hide();
          $(this.overlayElement).hide();
      };
      this.recalculatePosition = function()
      {
          if(this.root === undefined) return;
          $this = $(this.root);
          var offset = $this.offset();
          var width = this.modalElement.outerWidth();
          var widthO = $this.outerWidth();
          var height = $this.outerHeight();
          var windowWidth = $(window).width();
          var offsetOverFlow = 0;

          if((offset.left + width) > windowWidth){
              offsetOverFlow = ((offset.left + width) - windowWidth) + 1;
          }

          switch(this.params.menuAlign)
          {
              case "left":
                  this.modalElement.css({'left':(offset.left - offsetOverFlow)+'px'});
                  this.modalElement.css({'top':(offset.top + height)+'px'});
                  break;
              case "right":
                  this.modalElement.css({'left':(offset.left - width + widthO)+'px'});
                  this.modalElement.css({'top':(offset.top + height)+'px'});
                  break;
              case "center":
                  this.modalElement.css({'left':(offset.left - width/2 + widthO/2)+'px'});
                  this.modalElement.css({'top':(offset.top + height)+'px'});
                  break;
              case "up":
                  this.modalElement.css({'left':(offset.left - width + widthO)+'px'});
                  this.modalElement.css({'top':(offset.top - this.modalElement.outerHeight(true))+'px'});
                  break;
              default:
                  this.modalElement.css({'top':(offset.top + height)+'px'});
          }

      };

      var size = Modal.modals.length;
      for(var i = 0; i< size;i++)
      {
          var modal = Modal.modals.shift(); // mělo by to jet asi od konce, ale to budu řešit až bude více modalů v sobě
          if(modal.root !== undefined) {
              if($(modal.root).parents('#container').length === 0)
              {
                  modal.modalElement.remove();
                  $(modal.root).remove();
                  modal = undefined;
              } else Modal.modals.push(modal);
          } else Modal.modals.push(modal);
      }
  }
  Modal.create = function(_this)
  {
      var M = new Modal();
        $.extend(true,M.params,{
            'type':'menu',
            'overlay': 'none',
            'menuAlign': 'left',
            'modalClass': $(_this).attr('modalClass')
        });
        M.root = _this;
        if($(_this).hasClass('modal-right')) M.params.menuAlign = 'right';
        if($(_this).hasClass('modal-center')) M.params.menuAlign = 'center';
        if($(_this).hasClass('modal-up')) M.params.menuAlign = 'up';
        M.content = $(_this).find('.modal-content').html();
        $(_this).find('.modal-content').html('');
        M.render();
        $(M.modalElement).attr("class",$(M.modalElement).attr("class")+" "+$(_this).find('.modal-content').attr("class"));


        var __this = _this;
        $(M.modalElement).mouseleave(function(e){
            if(! $(e.toElement)!==$(__this)) {
                if(!$(__this).data("Modal").timer) {
                    $(__this).data("Modal").close();
                }
            };
        });
        $(_this).data("Modal",M);
  }







  $('.modal-window').each( function(index,element){
      var M = new Modal();
      $.extend(true,M.params,{
          'type':'window',
          'modalClass': $(this).attr('modalClass')
      });
      $(this).bind("modalOpen", M); // asi potom přesunout do objektu
      $(this).bind("modalClose", M);

      M.content = $(this).find('.modal-content').html();
      $(this).find('.modal-content').html('');
      $(this).remove('.modal-content');
      M.render();
  });

  $(document).on('mouseenter','.modal-menu',function(e){
      if($(this).data("Modal") === undefined){
        Modal.create(this);
      }
      var speed = 0;
      if($(this).attr('speed')){
        speed = parseInt($(this).attr('speed'));
      }
    $(this).data("Modal").open(undefined, speed);
  });
  $(document).on('mouseleave','.modal-menu',function(e){
    if($(this).data("Modal") === undefined){
      Modal.create(this);
    }
    if(! $(e.toElement).hasClass('modal') && ! $(e.relatedTarget).hasClass('modal')) {
        if(!$(this).data("Modal").timer) {
            $(this).data("Modal").close();
        }

    };
  });

  $('.products-categories-menu__product-category--modal-enabler--nojs')
    .removeClass('products-categories-menu__product-category--modal-enabler--nojs')
    .addClass('products-categories-menu__product-category--modal-enabler');

    $('.products-categories-menu__product-category--modal-enabler').on('mouseenter', function () {
        var modal = $(this).children('.product-categories-menu__product-category-modal');
        var nav = $(this).closest('.products-categories-menu__list');

        if (modal.hasClass('unibody__align-right')) {
            modal.css('right', ($(window).width() - nav.width()) / 2);
        }

        if (modal.hasClass('product-modal__for-companies')) {
            var item = $(this);
            modal.css('right', $(window).width() - item.offset().left - item.outerWidth());
        }
    });
});
